import React, {Component} from "react";
import {reduxForm} from "redux-form";
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import ChromeVideoApp from "./ChromeVideoApp";

class ModalChromeForm extends Component {

    render() {
        let instructions = [
            <span>Step 1: Install the extension&nbsp;
                <a href="https://chrome.google.com/webstore/detail/video-downloadhelper/lmjnegcaeklhafolokijcfjliaokphfk">
                Video DownloadHelper
            <img src="/_core/assets/themes/transcription/assets/img/ext_chrome.png"
                 alt="Video DownloadHelper"
                 width='16px'
                 height='16px'
            />
           </a>
        </span>,
            <span>Step 2:
                <br /> <span style={{margin: '10px'}} /> — <b>Non-Incognito</b> window:
                <br /> <span style={{margin: '15px'}} /> - Skip this step
                <br /> <span style={{margin: '10px'}} /> — <b>Incognito</b> window:
                <br /> <span style={{margin: '15px'}} /> - Choose the option "Manage extension" for installed extension on the Chrome Toolbar
                <br /> <span style={{margin: '15px'}} /> - Click the button "Allow in Incognito"
                <br /> <span style={{margin: '15px'}} /> - Click the button "Allow access to file URLs"
            </span>,
            <span>Step 3: Refresh the page and download the desired media on the Chrome Toolbar
        </span>,
            <span>Step 4: Upload the downloaded media from your device to our website</span>,
        ];

        return <form>
            <span className="label center">
                <Trans>Instruction - How To Download A Private Media From The Chrome Browser</Trans>
            </span>
            <ChromeVideoApp></ChromeVideoApp>
            <br></br>
            <td>
                {instructions.map(step => (
                    <li>
                        {step}
                    </li>
                ))}
            </td>
        </form>
    }
}

ModalChromeForm = reduxForm({
    form: 'ChromeForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(ModalChromeForm);

export default connect()(ModalChromeForm);